import * as IOTActions from '../Constants/index';

const InitialState = {
   machineStructure:{},
   moduleTypes:[],
   kitchenEvents:{},
   activeModuleType:"",
   activeModuleTypeData:{},
   activeModule:"",
   activeModuleData:{},
   activeSystem:"",
   kitchenStatus:"",
   kitchenOnlineStatus: false,
   doorStatuses: {},
   temperatureInfo: {},
   kitchenStates: {},
   machinePowerStatus: null,
   kitchenStatusTimeStamp: null,
   kitchenOnlineTimeStamp: null,
};

export const kitchen = (state = InitialState, action) => {
	switch (action.type) {

        case IOTActions.SET_MACHINE_STRUCTURE_DATA: 
			const { moduleTypes, ...rest } = action.data;
			const initialActiveModuleType = moduleTypes[0].moduleTypeId;
            return {
                ...state,
               moduleTypes,
			   machineStructure:rest,
			   activeModuleType: state.activeModuleType || initialActiveModuleType //Could have already been set by query params 
            }

		case IOTActions.SET_KITCHEN_EVENTS: 
			const { kitchenStaus, kitchenOnlineStatus, doorStatuses, temperatureInfo, kitchenStates, machinePowerStatus, kitchenStatusTimeStamp, kitchenOnlineTimeStamp, ...kitchenEvents } = action.data
            return {
                ...state,
				doorStatuses,
				kitchenStatus:kitchenStaus,
				kitchenOnlineStatus,
				kitchenEvents,
				temperatureInfo,
				kitchenStates,
				machinePowerStatus: machinePowerStatus ?? null,
				kitchenStatusTimeStamp: kitchenStatusTimeStamp ?? null,
				kitchenOnlineTimeStamp: kitchenOnlineTimeStamp ?? null,
            }

		case IOTActions.SET_ACTIVE_MODULE_TYPE: 
            return {
                ...state,
				activeModuleType:action.data,
            }

		case IOTActions.SET_ACTIVE_MODULE_TYPE_DATA:
			return {
				...state,
				activeModuleTypeData:action.data
			}

		case IOTActions.SET_ACTIVE_MODULE: 
			return {
				...state,
				activeModule:action.data
			}

		case IOTActions.SET_ACTIVE_MODULE_DATA:
			const initialActiveSystem = action.data?.["systems"] ? Object.keys(action.data["systems"])[0] : null;
			return {
				...state,
				activeModuleData:action.data,
				activeSystem:state.activeSystem || initialActiveSystem
			}

		case IOTActions.SET_ACTIVE_SYSTEM:
			return {
				...state,
				activeSystem:action.data
			}

		case IOTActions.SET_ACTIVE_SYSTEM_DATA:
			return {
				...state,
				activeSystemData:action.data
			}

		default:
			return {
				...state,
			};
	}
};

export default kitchen;
